import { render, staticRenderFns } from "./workDetails.vue?vue&type=template&id=ddf5eaae"
import script from "./workDetails.vue?vue&type=script&lang=js"
export * from "./workDetails.vue?vue&type=script&lang=js"
import style0 from "./workDetails.vue?vue&type=style&index=0&id=ddf5eaae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports